// extracted by mini-css-extract-plugin
export var Loader = "Spinner-module--Loader--4PcH4";
export var load2 = "Spinner-module--load2--ImJoX";